import { HlsJsStreamControllerState } from './HlsJsStreamControllerState';

import { Level, HlsConfig, Loader, LevelDetails, LoadStats } from 'hls.js';

import Hls from 'hls.js';

export interface IAbrController {
	_bwEstimator: IEwmaBandwidthEstimator;
}

export interface IBufferController {
	_levelDuration: number;
	mediaSource: MediaSource;
}

export interface ISubtitleStreamController {
	_getBuffered: () => any[];
	config: any;
	currentTrackId: number;
	doTick: () => void;
	fragCurrent: any
	fragPrevious: any;
	fragmentTracker: any;
	hls: any;
	media: HTMLVideoElement;
	state: string;
	tracksBuffered: any[];
	levels: any[];
	mediaBuffer: any;
	getLoadPosition: any;
	getFwdBufferInfo: any;
	getMaxBufferLength: any;
	mapToInitFragWhenRequired: any;
	loadFragment: any;
}

export interface IConfigExtended extends HlsConfig {
	captionsTextTrack1Label: string;
	fragType?: string;
	maxBufferHole: number;
	playerId: string;
	startPosition: number;
	xhrConfig: IXhrConfig;
}

export interface IEwmaBandwidthEstimator {
	canEstimate(): boolean;
	getEstimate(): number;
	sample(durationMs: number, numBytes: number): void;
}

export interface IFragmentExtended {
	loader: Loader<any>;
	start: number;
	_url: string;
}

export interface ILevelExtended extends Level {
	realBitrate: number;
	playlistBitrate: number;
}

export interface ILevelController {
	canload: boolean;
	//currentLevelIndex: number;
	firstLevel: number;
	level: number;
	levels: Level[];
	manualLevel: number;
	//manualLevelIndex: number;
	nextLoadLevel: number;
	startLevel: number;
	timer: number;

	clearTimer(): void;
	loadLevel(): void;
	startLoad(): void;
	stopLoad();
}

export interface ILevelDetailsExtended extends LevelDetails {
	url: string;
}

export interface IStatsExtended extends LoadStats {
	bwEstimate: number;
	tparsed?: number;
}

export interface IStreamController {
	currentLevel: number;
	fragCurrent: IFragmentExtended;
	lastCurrentTime: number;
	liveSyncPosition: number;
	nextBufferedFrag: IFragmentExtended;
	nextLevel: number;
	state: HlsJsStreamControllerState;
	stats: IStatsExtended;

	getBufferedFrag(position: number): IFragmentExtended;
	startLoad(startPosition: number): void;
	stopLoad(): void;
	doTick(): void;
}

export interface ITimelineController {
	initPTS: number[];
}

export interface IHlsJsExtended extends Hls {
	config: IConfigExtended;
	levels: ILevelExtended[];
	manualLevel: number;
	nextAutoLevel: number;
	subtitleDisplay: boolean;
	subtitleTrack: number;
	subtitleTracks: any[];
	timelineController: ITimelineController;
	audioTrack: number;
}

export interface IHlsJsTextTrack extends TextTrack {
	textTrack1?: boolean;
	previousCuesLength?: number;
}

export interface IXhrConfig {
	additionalHeaders: Record<string, string>;
	mimeType: string;
	withCredentials: boolean;
}

/**
 * Hls.js const and enums
 */
export const State = {
	STOPPED: 'STOPPED',
	IDLE: 'IDLE',
	KEY_LOADING: 'KEY_LOADING',
	FRAG_LOADING: 'FRAG_LOADING',
	FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
	WAITING_TRACK: 'WAITING_TRACK',
	PARSING: 'PARSING',
	PARSED: 'PARSED',
	ENDED: 'ENDED',
	ERROR: 'ERROR',
	WAITING_INIT_PTS: 'WAITING_INIT_PTS',
	WAITING_LEVEL: 'WAITING_LEVEL',
};

export const enum FragmentState {
	NOT_LOADED = 'NOT_LOADED',
	APPENDING = 'APPENDING',
	PARTIAL = 'PARTIAL',
	OK = 'OK',
}

export const enum PlaylistLevelType {
	MAIN = 'main',
	AUDIO = 'audio',
	SUBTITLE = 'subtitle',
}

